<template>
    <div class="msgbl-actions">
      <div>
        <v-btn v-for="a in actionsToShow" 
              :key="a.name"
              text
              @click="actionsClicked({title: a.name_h, action: a.name})"
              class="action-btn">
              {{a.name_h}}
        </v-btn>
      </div>
      <DropdownMenu v-if="menu" :items="menu" @item-clicked="actionsClicked">
        <v-icon>icon-dots-three-horizontal</v-icon>
      </DropdownMenu>
    </div>
</template>

<script>
import {DropdownMenu} from "@/modules/common/components"

export default {
  name: 'MsgblActions',
  components: {
    DropdownMenu
  },
  props: {
    actions: {
      type: Array,
      required: true,
    },
  },
  computed: {
    actionsToShow(){
      return this.actions.slice(0, 2)
    },
    menu(){
      return this.actions.length > 2 ? this.sliceActions() : null
    },
  },
  methods: {
    actionsClicked(ev) {
      this.$emit('action', ev)
    },
    sliceActions() {
      return this.actions
              .slice(2, this.actions.length)
              .map(item => ({title: item.name_h, action: item.name}))
    }
  } 
}
</script>
<style lang="scss">
@import '@/assets/scss/abstract/_variables';
@import '@/assets/scss/abstract/_i18n-mixins';

.msgbl-actions {
  border-top: 1px solid $grey-color-7;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @include i-padding-mirror(0, 10px);
  margin-top: 10px;

  .action-btn.v-btn, .theme--light.v-icon {
    color: $navy-color-1;
    cursor: pointer;
    height: 28px;
  }

  .action-btn.v-btn {
    letter-spacing: normal;
    font-size: 10px;
    font-weight: 600;
  }
}
</style>
